import { Skeleton, Column } from 'components/Blocks';

export function LoadingBalances(): JSX.Element {
  return (
    <Column alignItems="center">
      <Skeleton quantity={3} orientation="horizontal" gap="6" height={240} width={240} />

      <Skeleton height={32} width="60%" />
    </Column>
  );
}
